// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"464":"d6ed8c3b","592":"bf6ca574"}[chunkId] + ".chunk.js";
};